<template>
	<!-- begin #footer -->
	<div id="footer" class="footer">
		&copy; 2018 chovancova.sk 
	</div>
	<!-- end #footer -->
</template>

<script>
import PageOptions from '../../config/PageOptions.vue'

export default {
  name: 'Footer',
  data() {
		return {
			pageOptions: PageOptions
		}
  }
}
</script>
